<template>
  <thead>
    <tr class="grid-excel-index">
      <th
        v-for="(column, idx) in columns"
        :key="idx"
        colspan="1"
        rowspan="1"
        :name="`cell_${idx + 1}`"
        :class="cellClass(column)"
        @click.stop="(e) => handleClick(column, e)"
      >
        <div class="header-cell">
          <slot :item="column" :index="idx">{{ column.text }}</slot>
        </div>
        <div class="column-resizable"></div>
      </th>
    </tr>
  </thead>
</template>
<script>
export default {
  name: "grid-header-content",
  props: {
    columns: {
      type: Array,
    },
    classMethod: {
      type: Function,
    },
  },
  methods: {
    cellClass(column) {
      const { classMethod } = this;
      if (classMethod) {
        return classMethod({ column });
      }
      return {};
    },
    handleClick(column, event) {
      if (this.$listeners["click-cell"]) {
        this.$emit("click-cell", { column }, event);
      }
    },
  },
};
</script>
